export default __webpack_public_path__ + "static/media/Welcome-gif-3.f4fc274b.png";